<template>
  <div>
    <e-row mr>
      <e-col>
        <erp-s-field
            view="tl"
            label="Modelo de Cobrança de Arremate:"
        >
          <documento-select code="comunicacao.arrematante.cobranca-arremate" v-model="leilao.config.templateCobranca" />
        </erp-s-field>
      </e-col>
      <e-col>
        <erp-s-field
            view="tl"
            label="Modelo de Nota de Arrematação:"
        >
          <documento-select code="documentos-leilao-notas-arrematacao" v-model="leilao.config.templateNota" />
        </erp-s-field>
      </e-col>
    </e-row>
    <e-row class="m-t" mr>
      <e-col>
        <erp-s-field
            view="tl"
            label="Recibo de Arremate:"
        >
          <documento-select code="documentos-leilao-recibos" v-model="leilao.config.templateRecibo" />
        </erp-s-field>
      </e-col>
      <e-col>
        <erp-s-field
            view="tl"
            label="E-mail de confirmação de Habilitação:"
        >
          <documento-select code="documentos-leilao-termos" v-model="leilao.config.templateHabilitacao" />
        </erp-s-field>
      </e-col>
    </e-row>
  </div>
</template>

<script>
import ERow from "@/components/layout/components/Row"
import ECol from "@/components/layout/components/Col"
import DocumentoSelect from "@/components/documentos/components/include/DocumentoSelect"
import {ErpSField} from "uloc-vue-plugin-erp"

export default {
  name: "Automacao",
  components: {
    DocumentoSelect,
    ECol,
    ERow,
    ErpSField
  },
  props: ['leilao']
}
</script>
